/* eslint-disable newline-per-chained-call */
/* eslint-disable class-methods-use-this */
import ApplicationController from '../application_controller';

const MODALIDAD_NOMBRE_COLUMN = 1;

/* global $, Backbone, Cifra, I18n, set_overlay, swal, set_overlay_ajax, toastr */
const SuscripcionesCollection = Backbone.Collection.extend({
  seleccionModalidad(modalidadId, seleccionado) {
    this.where({ modalidad_id: parseInt(modalidadId, 10) }).forEach((element) => {
      element.set('seleccionado', seleccionado);
    });
    this.trigger('seleccion:change', this);
  },
  seleccionarSuscripcion(servicioAlumnoId, seleccionado) {
    this.where({ servicio_alumno_id: parseInt(servicioAlumnoId, 10) }).forEach((element) => {
      element.set('seleccionado', seleccionado);
    });
    this.trigger('seleccion:change', this);
  },
  resetearConModalidades(idsOriginales) {
    const ids = idsOriginales.map((e) => parseInt(e, 10));
    this.forEach((element) => {
      element.set('seleccionado', ids.includes(element.get('modalidad_id')));
    });
    this.trigger('seleccion:change', this);
  },
  getJsonSeleccionados() {
    return this._seleccionados().map((m) => m.toJSON());
  },
  getIdsSuscripcionesSeleccionadas() {
    return this._seleccionados().map((m) => m.get('servicio_alumno_id'));
  },
  _seleccionados() {
    return this.where({ seleccionado: true });
  },
});

/**
 * Parte de la base de que cada vez que se carga la búsqueda se
 * pone visible el resumen y oculto el detalle
 */
export default class extends ApplicationController {
  connect() {
    this.$wrapperResultado = $('#resultado-busqueda');
    this.$filtros = $('#generar_facturas_filtros');
    this.tablaDetalle = undefined;
    this._conectarEventos();
    this._cargarModalidades();

    // TODO: Estos eventos de abajo, los lanza a mano la vista del servidor cuando
    // responde con el partial to wrapper, habría que migrarlo
    Cifra.App.on('start:generar_facturas:buscar', () => {
      this.recargarBusqueda();
    });

    Cifra.App.on('start:generar_facturas:create', () => {
      this.overlay_generacion.hide();
      this.cargarTablaGeneradas();
    });
  }

  disconnect() {
    Cifra.App.off('start:generar_facturas:buscar');
    Cifra.App.off('start:generar_facturas:create');
  }

  recargarBusqueda() {
    const data = Cifra.Shared.GeneracionFacturasData || [];
    data.forEach((m) => { m.seleccionado = true; });

    this.gestorDatos = new SuscripcionesCollection(data);
    this.gestorDatos.on('seleccion:change', (_collection) => {
      this._actualizarSeleccionados();
    });
    this._actualizarSeleccionados();
    this._destruirTablaDetalle();
    if (this.overlayFiltros) {
      this.overlayFiltros.hide();
    }
    // Conectamos aquí los eventos de los checks para funcione correctamente
    // al llamar desde seleccionar-todo
    this._conectarEventoChecks();
    // NO cargamos la tabla hasta que no den click a la vista de detalle
  }

  _destruirTablaDetalle() {
    if (this.tablaDetalle) {
      this.tablaDetalle.destroy();
      this.tablaDetalle = undefined;
    }
  }

  _cargarTablaDetalle() {
    if (this.tablaDetalle) {
      this.tablaDetalle.clear();
      this.tablaDetalle.rows.add(this.gestorDatos.getJsonSeleccionados());
      this.tablaDetalle.draw();
    } else {
      this.tablaDetalle = $('#vista-detalle table').DataTable({
        data: this.gestorDatos.getJsonSeleccionados(),
        columns: [
          { data: 'servicio' },
          { data: 'modalidad' },
          { data: 'alumno' },
          { data: 'grupo' },
          { data: 'pagador' },
          {
            data: 'total',
            render: Cifra.Utils.precio,
            className: 'text-right',
          },
          {
            data: 'servicio_alumno_id',
            render(data, type, row, _meta) {
              const icono = row.seleccionado ? 'fas fa-check-square' : 'fa fa-square';
              return `<i class="${icono} fa-16x icon-checkbox" data-servicio-alumno-id="${data}"></i>`;
            },
          },
        ],
        info: false,
        searchDelay: 350,
        paging: false,
        order: [[MODALIDAD_NOMBRE_COLUMN, 'asc']],
        scrollY: '400px',
        scrollCollapse: true,
        // La columna del check no ordenable
        columnDefs: [{
          targets: 'nosort',
          orderable: false,
        }],
        language: I18n.t('datatables'),
      });
    }
    // para que siempre la primera acción del botón sea desmarcar
    this.$wrapperResultado.find('#btn-sel-todo-detalle').removeClass('marcar');
  }

  cargarTablaGeneradas() {
    this.tablaDetalle = $('#tabla-generadas').DataTable({
      info: false,
      searchDelay: 350,
      paging: false,
      order: [[0, 'asc']],
      scrollY: '400px',
      scrollCollapse: true,
      // La columna del check no ordenable
      columnDefs: [{
        targets: 'nosort',
        orderable: false,
      }],
      language: I18n.t('datatables'),
    });
  }

  _conectarEventos() {
    const self = this;
    this.$filtros.on('change', '#serie_id', () => {
      self._cargarModalidades();
    }).on('submit', () => {
      self.overlayFiltros = set_overlay(self.$filtros);
      self._limpiarResultados();
    }).on('show.bs.tab hidden.bs.tab', '.nav-radios input', () => {
      // Cuando cambian de tab con los checks de alumno, pagador y grupos hay que limpiar
      this._limpiarSelectoresTabs();
    });

    this.$wrapperResultado.on('click', '#btn-cambiar-vista', () => {
      const $detalle = $('#vista-detalle');
      const cambioHaciaDetalle = !$detalle.hasClass('visible');

      if (cambioHaciaDetalle) {
        self._toggleVistaResultados();
      } else {
        swal({
          title: I18n.t('atencion'),
          text: I18n.t('generacion_aviso_vista_general'),
          type: 'warning',
          html: false,
          showCancelButton: true,
          confirmButtonColor: '#fe1d12',
          confirmButtonText: I18n.t('Aceptar'),
          cancelButtonText: I18n.t('Cancelar'),
        },
        // eslint-disable-next-line prefer-arrow-callback
        function onConfirm(isConfirmed) {
          if (isConfirmed) {
            self._toggleVistaResultados();
          }
        });
      }
    }).on('submit', '#generar_facturas_form', (e) => {
      if (!self.submitGenerarReal) {
        e.preventDefault();
        this._preguntarGeneracion();
        return false;
      }

      const ids = this.gestorDatos.getIdsSuscripcionesSeleccionadas().join(',');
      this.$wrapperResultado.find('#generacion_facturas_suscripciones_ids').val(ids);
      this.submitGenerarReal = false;
      return true;
    }).on('click', '#cerrar-facturas', (e) => {
      e.preventDefault();
      self._cerrarFacturas();
    }).on('click', '#eliminar-facturas', (e) => {
      e.preventDefault();
      self._eliminarFacturas();
    }).on('click', '.icon-checkbox', (e) => {
      const $icono = $(e.currentTarget);
      // Datos que están actualmente en la tabla
      const dataEnTabla = this.tablaDetalle.row($(e.currentTarget).closest('tr')).data();
      this.gestorDatos.seleccionarSuscripcion($icono.data('servicio-alumno-id'), !dataEnTabla.seleccionado);
      dataEnTabla.seleccionado = !dataEnTabla.seleccionado;
      // Volvemos a poner el mismo valor pero así renderiza la celda y pone el nuevo icono
      // this.tablaDetalle.cell(
      //   $(e.currentTarget).closest('td')
      // ).data(dataEnTabla.servicio_alumno_id);
      this.tablaDetalle.cell($(e.currentTarget).closest('td')).invalidate();
    }).on('click', '#btn-sel-todo-detalle', (e) => {
      const $boton = $(e.currentTarget);
      const overlay = set_overlay(this.$wrapperResultado);
      setTimeout(() => {
        let seleccionar = false;
        if ($boton.hasClass('marcar')) {
          seleccionar = true;
        }
        $boton.toggleClass('marcar');
        this.tablaDetalle.data().toArray().forEach((m) => {
          m.seleccionado = seleccionar;
          this.gestorDatos.seleccionarSuscripcion(m.servicio_alumno_id, seleccionar);
        });
        this.tablaDetalle.rows().invalidate();
        overlay.hide();
      });
    });
  }

  _conectarEventoChecks() {
    $('.selector-modalidad').on('change', (e) => {
      const $input = $(e.currentTarget);
      this.gestorDatos.seleccionModalidad($input.val(), $input.is(':checked'));
    });
  }

  _cargarModalidades() {
    const $inputSerie = this.$filtros.find('#serie_id');
    this._limpiarResultados();

    // Esto es un truco bastante sucio para obtener un controller de
    // Stimulus asociado a un elemento. Cuando se migre todo a Vue ya
    // estará mejor, de momento como workaround nos vale
    const select2Controller = window.Stimulus.getControllerForElementAndIdentifier(
      this.$filtros.find('#servicios_ids')[0], 'select2',
    );

    // Todavía no ha cargado el controlador de stimulus, hacemos super ñapa para esperar
    // y volver a intentarlo hasta que cargue
    if (!select2Controller) {
      setTimeout(() => {
        this._cargarModalidades();
      }, 200);
      return;
    }

    const { select2Cifra } = select2Controller;

    select2Cifra.element.disabled = true;
    Cifra.Api.ge.modalidades.getAgrupadasSelect2(
      { params: { serie_id: $inputSerie.val(), activa: true } },
    ).then((modalidades) => {
      select2Cifra.setOptions(modalidades);
      select2Cifra.element.disabled = false;
    }).catch(() => {
      select2Cifra.element.disabled = false;
    });
  }

  _limpiarResultados() {
    this.$wrapperResultado.html('');
    this.tablaDetalle = undefined;
  }

  _limpiarSelectoresTabs() {
    this.$filtros.find('.tabs-nav-radios select').val(null).trigger('change');
  }

  _toggleVistaResultados() {
    const $inputVista = $('#generacion_facturas_vista');
    const $resumen = $('#vista-resumen');
    const $detalle = $('#vista-detalle');
    const cambioHaciaDetalle = !$detalle.hasClass('visible');
    const $visible = $resumen.hasClass('visible') ? $resumen : $detalle;
    const $novisible = $resumen.hasClass('visible') ? $detalle : $resumen;
    $novisible.toggleClass('visible hide').show();
    $visible.toggleClass('visible hide').hide();
    if (cambioHaciaDetalle) {
      const overlay = set_overlay(this.$wrapperResultado);
      setTimeout(() => {
        this._destruirTablaDetalle();
        this._cargarTablaDetalle();
        overlay.hide();
      });
      $inputVista.val('detalle');
      $('.etiqueta-vista').text(I18n.t('vista_general'));
    } else {
      $inputVista.val('resumen');
      $('.etiqueta-vista').text(I18n.t('vista_detallada'));
      this.gestorDatos.resetearConModalidades(this._getModalidadesSeleccionadas());
    }
  }

  _preguntarGeneracion() {
    const self = this;
    swal({
      title: I18n.t('atencion'),
      text: I18n.t('generacion_aviso_generar_facturas', {
        numero: this.gestorDatos.getIdsSuscripcionesSeleccionadas().length,
      }),
      type: 'info',
      html: false,
      showCancelButton: true,
      confirmButtonColor: '#fe1d12',
      confirmButtonText: I18n.t('Aceptar'),
      cancelButtonText: I18n.t('Cancelar'),
    },
    // eslint-disable-next-line prefer-arrow-callback
    function onConfirm(isConfirmed) {
      if (isConfirmed) {
        self.submitGenerarReal = true;
        // Se oculta en el evento de respuesta del create conectado arriba
        self.overlay_generacion = set_overlay_ajax($('body'));
        $('#generar_facturas_form').submit();
      }
    });
  }

  _cerrarFacturas() {
    const url = $('#cerrar-facturas').attr('href');
    const ids = this._getFacturasSeleccionadas();

    if (ids.length < 1) {
      toastr.error(I18n.t('error_debe_seleccionar_uno'));
      return;
    }

    const overlay = set_overlay(this.$wrapperResultado);
    $.post(url, { facturas_ids: ids }).always(() => {
      overlay.hide();
    });
  }

  _eliminarFacturas() {
    const self = this;
    const ids = this._getFacturasSeleccionadas();

    if (ids.length < 1) {
      toastr.error(I18n.t('error_debe_seleccionar_uno'));
      return;
    }

    swal({
      title: I18n.t('atencion'),
      text: I18n.t('generacion_aviso_eliminar_facturas', {
        numero: ids.length,
      }),
      type: 'warning',
      html: false,
      showCancelButton: true,
      confirmButtonColor: '#fe1d12',
      confirmButtonText: I18n.t('Aceptar'),
      cancelButtonText: I18n.t('Cancelar'),
    },
    // eslint-disable-next-line prefer-arrow-callback
    function onConfirm(isConfirmed) {
      if (isConfirmed) {
        const url = $('#eliminar-facturas').attr('href');

        const overlay = set_overlay(self.$wrapperResultado);
        $.post(url, { facturas_ids: ids }).always(() => {
          overlay.hide();
        }).done(() => {
          const selector = ids.map((id) => `tr[data-factura-id=${id}]`).join(',');
          self.tablaDetalle
            .rows(selector)
            .remove()
            .draw();
        });
      }
    });
  }

  _getSuscripcionesSeleccionadas() {
    return Cifra.Utils.valuesForInputs($('.selector-suscripcion:checked'));
  }

  _getModalidadesSeleccionadas() {
    return Cifra.Utils.valuesForInputs($('.selector-modalidad:checked'));
  }

  _getFacturasSeleccionadas() {
    const $checks = this.$wrapperResultado.find('#tabla-generadas .check-factura:checked');
    return Cifra.Utils.valuesForInputs($checks);
  }

  _actualizarSeleccionados() {
    this.$wrapperResultado.find('#num-seleccionadas').text(this.gestorDatos.getIdsSuscripcionesSeleccionadas().length);
  }
}
